import Input from "../../../../components/Input/Input";
import Select from "../../../../components/Select/Select";
import Checkbox from "../../../../components/CheckBox/Checkbox";
import DatePicker from "../../../../components/DatePicker/DatePicker";
import DatetimePicker from "../../../../components/DatePicker/DatetimePicker";

const Controls = {
  Input,
  Select,
  Checkbox,
  DatePicker,
  DatetimePicker,
};

export default Controls;
